import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import insertlogo from '../../Assets/App_icon/insert.png';
import backlogo from '../../Assets/App_icon/back.png';

const PartyMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false); 
  
  const [expList, setExpList] = useState([]);
  const [partyType, setPartyType] = useState('');
  const [partyList, setPartyList] = useState([]);
  const [selectedExp, setSelectedExp] = useState('');

 
  const today = new Date().toISOString().split("T")[0];
  const [entryDate, setEntryDate] = useState(today);

  const fetchExpenceList = async () => { 
          try {
            const response = await fetch(`${host_url}/expence_mlist`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                expDetail: '',
                sdate: startDate,
                edate: endDate,
              }),
            });
            const data = await response.json();
            setExpList(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }    
      }; 

  const handleBack = () => {
    navigate('../dashboard');
  };

    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible || addmodalVisible) {
            setModalVisible(false);
            setAddModalVisible(false);
            setSelectedExp('');
          } else {
            handleBack();
          }
        }
        
        if (event.key === "Insert" && !addmodalVisible) {
          setAddModalVisible(true);
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, addmodalVisible]);

    useEffect(() => { 
     fetchExpenceList(); 
    }, [host_url]);  // Expence List Detail


    useEffect(() => { 
        if (partyType === null || partyType === undefined) return;
        const accountDetail = {
            acc_type: partyType,
        };
        const fetchAccountList = async () => { 
          try {
            const response = await fetch(`${host_url}/account_select`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                accDetail: accountDetail,
              }),
            });            
            const data = await response.json();
            setPartyList(data);             
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
        }; 
        fetchAccountList(); 
    }, [partyType]); // Account List

    const sdate = new Date();
    sdate.setMonth(sdate.getMonth());
    sdate.setDate(1);
    const ThreeMonthAgo = sdate.toISOString().split("T")[0];

    const edate = new Date();
    edate.setMonth(edate.getMonth());
    edate.setDate(edate.getDate());
    const currentDate = edate.toISOString().split("T")[0];
    
    const [startDate, setStartDate] = useState(ThreeMonthAgo);
    const [endDate, setEndDate] = useState(currentDate);
    const [partyNameFilter, setPartyNameFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');

    const filteredExpList = expList.filter(exp => {
      const expDate = new Date(exp.exp_date); 
      const start = startDate ? new Date(startDate) : null;
      if (start) {
        start.setDate(start.getDate() - 1); // Subtract 1 day
      }
      const end = endDate ? new Date(endDate) : null;
      if (end) {
        end.setDate(end.getDate() + 1); // ✅ +1 day
      }
      
      return (
        exp.sacc_name.toLowerCase().includes(partyNameFilter.toLowerCase()) &&
        exp.exp_type.toLowerCase().includes(typeFilter.toLowerCase())&&
        (!start || expDate >= start) && 
        (!end || expDate <= end)
      );
    });


    const totalCount = filteredExpList.length;
    const totalAmt = filteredExpList.reduce((sum, exp) => sum + Number(exp.exp_amt), 0);
   
    const handleAccDetail = (exp) => {
      setModalVisible(true);
      setSelectedExp(exp);
      setPartyType(exp.sacc_type);
    };

    // Functions for handling the different actions
    const handleAddExp = async () => {
      setAddModalVisible(false);
      const expDetail = {
              exp_id: 0, 
              exp_date: today,
              exp_type: selectedExp.exp_type, 
              exp_party_id: selectedExp.exp_party_id, 
              exp_amt: selectedExp.exp_amt,
              exp_detail: selectedExp.exp_detail || '',
              sacc_type: partyType,
      };
      
      try {
        const response = await fetch(`${host_url}/expence_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'exp_insert',
            store: store,
            suId : '',
            expDetail: expDetail,
            sdate: startDate,
            edate: endDate,
          }),
        });
        const data = await response.json();
        setExpList(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleUpdateExp = async () => {
      setModalVisible(false);
      const expDetail = {
              exp_id: selectedExp.exp_id, 
              exp_date: today,
              exp_type: selectedExp.exp_type, 
              exp_party_id: selectedExp.exp_party_id, 
              exp_amt: selectedExp.exp_amt,
              exp_detail: selectedExp.exp_detail || '',
              sacc_type: partyType,
      };
      try {
        const response = await fetch(`${host_url}/expence_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'exp_update',
            store: store,
            expDetail: expDetail,
            sdate: startDate,
            edate: endDate,
          }),
        });
        const data = await response.json();
        setExpList(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleDeleteExp = async () => {
      setModalVisible(false);
      const userConfirmed = window.confirm('Are you sure you want to delete this Entry?');
      if (userConfirmed) {
        try {
          const response = await fetch(`${host_url}/expence_mlist`, {
            method: 'POST', 
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              type: 'exp_delete',
              store: store,
              expDetail: selectedExp,
              sdate: startDate,
              edate: endDate,
            }),
          });
          const data = await response.json();
          if (data.message) {
              alert(data.message); 
          } else {
              setExpList(data);
          }
          
        } catch (error) {
          console.error('Error fetching cities:', error);
        }
      }  
    };

  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Expence Master</b>
              <div onClick={() => {setSelectedExp(''); setAddModalVisible(true); }}>
                <img src={insertlogo} alt="Back" className='system-icon'/>
              </div>
          </div>
         
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th ><input type="date" className="search-input  no-icon" style={{ textAlign: 'center' }} value={startDate} onChange={(e) => setStartDate(e.target.value)} onBlur={fetchExpenceList}/></th>
                <th>Type</th>
                <th colSpan='2' >Party Name</th>
                <th>Amount</th>
              </tr>
              <tr>
                <th ><input type="date" className="search-input  no-icon" style={{ textAlign: 'center' }} value={endDate} onChange={(e) => setEndDate(e.target.value)} onBlur={fetchExpenceList} /></th>
                <th>
                  <select
                    className="search-input"
                    value={typeFilter}
                    onChange={(e) => setTypeFilter(e.target.value)}
                  >
                    <option value="">All Types</option>
                    <option value="Cash_Back">Cash_Back</option>
                    <option value="Office_Exp">Office_Exp</option>
                    <option value="Salary_Exp">Salary_Exp</option>
                    <option value="Petrol_Exp">Petrol_Exp</option>
                    <option value="Rent_Exp">Rent_Exp</option>
                    <option value="Trans_Exp">Trans_Exp</option>
                    {/* Add more roles as needed */}
                  </select>
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={partyNameFilter}
                    onChange={(e) => setPartyNameFilter(e.target.value)}
                  />
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredExpList.map((row, index) => {
                  return (
                    <tr key={index} style={{ lineHeight: '10px' }} onClick={row.exp_type === 'Cash_Back' ? undefined : () => handleAccDetail(row)}>
                      <td >{new Date(row.exp_date).toLocaleDateString("en-GB").replace(/\//g, "-")}</td>                      
                      <td className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.exp_type}</span></td>
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.sacc_name}</span></td>
                      <td className="cell-right"><span style={{ paddingRight: '10px' }}>{row.exp_amt}</span></td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px' }}>{totalCount}</span></th>
                <th className="cell-left"></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}>{totalAmt}</span></th>
              </tr>
            </tfoot>
          </table>
          

          {/* Modal for Expence Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >User Detail</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td className="cell-left">Exp Type</td>
                        <td><select
                              value={selectedExp.exp_type}
                              onChange={(e) => setSelectedExp({ ...selectedExp, exp_type: e.target.value })}
                            >
                              <option value="">Select Expence</option>
                              <option value="Cash_Back">Cash_Back</option>
                              <option value="Office_Exp">Office_Exp</option>
                              <option value="Salary_Exp">Salary_Exp</option>
                              <option value="Petrol_Exp">Petrol_Exp</option>
                              <option value="Rent_Exp">Rent_Exp</option>
                              <option value="Trans_Exp">Trans_Exp</option>  
                            </select>
                        </td>                      
                      </tr>
                      <tr>
                        <td className="cell-left">Party Type</td>
                        <td>
                            <select
                              value={partyType}
                              onChange={(e) => setPartyType(e.target.value)}
                            >
                              <option value="">Select Types</option>
                              <option value="Pur_Party">Pur_Party</option>
                              <option value="Salary_Party">Salary_Party</option>
                              <option value="Exp_Party">Exp_Party</option>
                              <option value="CashBank_Party">CashBank_Party</option>
                              {/* Add more roles as needed */}
                            </select>
                        </td>                      
                      </tr>
                      <tr>
                        <td className="cell-left">Party Name</td>
                        <td>
                          <select
                            value={selectedExp.exp_party_id}
                            onChange={(e) => setSelectedExp({ ...selectedExp, exp_party_id: e.target.value })}
                          >
                            <option key='' value=''>Select Party</option>
                            {partyList.length > 0 && 
                              partyList.map((partyList, index) => (
                                <option key={index} value={partyList.sacc_id}>
                                  {partyList.sacc_name}
                                </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td className="cell-left">Amount</td>
                        <td><input type="text" value={selectedExp.exp_amt}  onChange={(e) => {setSelectedExp({...selectedExp, exp_amt: e.target.value.replace(/[^0-9]/g, '').slice(0, 7) }); }} /> </td>
                      </tr>
                      <tr>
                        <td className="cell-left">Remark</td>
                        <td><input type="text" value={selectedExp.exp_detail} onChange={(e) => setSelectedExp({ ...selectedExp, exp_detail: e.target.value })}/></td>
                      </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="danger" style={{ flex: 1, marginRight: '10px' }} onClick={handleDeleteExp}>
                      Delete
                    </Button>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleUpdateExp}>
                      Update
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => {setModalVisible(false); setSelectedExp(''); setPartyType('') }}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>

          {/* Modal for Add New Expence Entry */}
            <Modal isOpen={addmodalVisible} toggle={() => setModalVisible(!addmodalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Add New Entry</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td className="cell-left">Exp Type</td>
                        <td><select
                              value={selectedExp.exp_type}
                              onChange={(e) => setSelectedExp({ ...selectedExp, exp_type: e.target.value })}
                            >
                              <option value="">Select Expence</option>
                              <option value="Office_Exp">Office_Exp</option>
                              <option value="Salary_Exp">Salary_Exp</option>
                              <option value="Petrol_Exp">Petrol_Exp</option>
                              <option value="Rent_Exp">Rent_Exp</option>
                              <option value="Trans_Exp">Trans_Exp</option>  
                            </select>
                        </td>                      
                      </tr>
                      <tr>
                        <td className="cell-left">Party Type</td>
                        <td>
                            <select
                              value={partyType}
                              onChange={(e) => setPartyType(e.target.value)}
                            >
                              <option value="">Select Types</option>
                              <option value="Pur_Party">Pur_Party</option>
                              <option value="Salary_Party">Salary_Party</option>
                              <option value="Exp_Party">Exp_Party</option>
                              <option value="CashBank_Party">CashBank_Party</option>
                              {/* Add more roles as needed */}
                            </select>
                        </td>                      
                      </tr>
                      <tr>
                        <td className="cell-left">Party Name</td>
                        <td>
                          <select
                            value={selectedExp.exp_party_id}
                            onChange={(e) => setSelectedExp({ ...selectedExp, exp_party_id: e.target.value })}
                          >
                            <option key='' value=''>Select Party</option>
                            {partyList.length > 0 && 
                              partyList.map((partyList, index) => (
                                <option key={index} value={partyList.sacc_id}>
                                  {partyList.sacc_name}
                                </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td className="cell-left">Amount</td>
                        <td><input type="text" value={selectedExp.exp_amt}  onChange={(e) => {setSelectedExp({...selectedExp, exp_amt: e.target.value.replace(/[^0-9]/g, '').slice(0, 7) }); }} /> </td>
                      </tr>
                      <tr>
                        <td className="cell-left">Remark</td>
                        <td><input type="text" value={selectedExp.exp_detail} onChange={(e) => setSelectedExp({ ...selectedExp, exp_detail: e.target.value })}/></td>
                      </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleAddExp}>
                      Add New
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => {setAddModalVisible(false); setSelectedExp(''); }}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>  

    </div>
  );
};

export default PartyMaster;
